module.exports = __webpack_public_path__ + "static/media/upgrade.58b4bf7b.png";